<template>
  <div
    v-bind:style="showModal ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-info" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Comprobante de combustible despachado</h5>
          <button
            @click="close"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
          <div class="modal-body" :style="`background-image: url(${voucher}); height: 600px; background-size: contain; background-position: center; background-repeat: no-repeat;`"/>
            <!-- <img :src="modal_km.image" width="400" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
export default {
  name: "Modal",
  props: ["showModal", "voucher"],
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>